<template>
  <div
    :class="colClass"
    :style="colStyle"
  >
    <slot></slot>
  </div>
</template>
<script>
import { NAME_PRE } from '@/packages/constant/index';

export default {
  name: `${NAME_PRE}-col`,

  props: {
    span: {
      type: Number,
      default: 24,
    },

    offset: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      gutter: 0,
    };
  },

  computed: {
    colClass() {
      // 统一样式管理
      let classes = [`${NAME_PRE}-col`];
      classes.push(`${NAME_PRE}-col-${this.span}`);

      if (this.offset) {
        // 有便宜量，则加上新的样式
        classes.push(`${NAME_PRE}-col-offset-${this.offset}`);
      }

      return classes;
    },

    colStyle() {
      let style = {};
      if (this.gutter) {
        style = {
          ...style,
          paddingLeft: `${this.gutter / 2}px`,
          paddingRight: `${this.gutter / 2}px`,
        };
      }
      return style;
    },
  },
};
</script>
